import * as React from 'react';
import styled from 'styled-components';
import { FlexRowCenterVertical } from '../../..';
import { CheckBox } from '../General/Checkbox';
import { __ } from 'react-i18n';
import { rem } from 'polished';

interface Props {
  handleCheckboxChange: any;
  filters: any;
  isB2B?: boolean;
  label: string;
  marginLeft?: number;
  marginRight?: number;
}

export function CategoryFilterCheckboxes({
  handleCheckboxChange,
  filters,
  label,
  marginLeft,
  marginRight,
}: Props) {
  const handleChange = e => {
    const { value, name } = e.target;
    handleCheckboxChange({ name, value });
  };

  return (
    <CheckboxWrapper>
      <CheckBox
        wrapperStyle={{
          marginLeft: marginLeft ?? rem(16),
          marginRight: marginRight ?? rem(30),
          marginBottom: 0,
        }}
        label={__(`${label}`)}
        type={'checkbox'}
        onClick={handleChange}
        selected={filters.onlyAvailable === '1' ? true : false}
        name="onlyAvailable"
        border={'#D2A4B052'}
      />
    </CheckboxWrapper>
  );
}

const CheckboxWrapper = styled(FlexRowCenterVertical)`
  margin-left: ${rem(24)};
  flex-flow: row wrap;

  flex-flow: column;
  margin: 0;
  align-items: flex-start;

  ${({ theme }) => theme.mediab.s450`
    
  `}
`;
